import { render, staticRenderFns } from "./ShowMatching.vue?vue&type=template&id=1ea72ddb&scoped=true"
import script from "./ShowMatching.vue?vue&type=script&lang=js"
export * from "./ShowMatching.vue?vue&type=script&lang=js"
import style0 from "./ShowMatching.vue?vue&type=style&index=0&id=1ea72ddb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea72ddb",
  null
  
)

export default component.exports